import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { CommonAxiosResponse } from 'src/types';
import {
  CommonCustomerPaymentPayload,
  CustomerPaymentComputationResponse,
  CustomerPaymentListResponse
} from './types';

export const customerPaymentListThunk = createAsyncThunk<
  CommonAxiosResponse<CustomerPaymentListResponse>,
  CommonCustomerPaymentPayload,
  { state: RootState }
>('customer-payment/customerPaymentListThunk', async (data) => {
  const response = await Api.post('/customer/payment/get', {
    ...data,
    action: 'list'
  });
  return response;
});

export const customerPaymentComputationThunk = createAsyncThunk<
  CommonAxiosResponse<CustomerPaymentComputationResponse>,
  CommonCustomerPaymentPayload,
  { state: RootState }
>('customer-payment/customerPaymentComputationThunk', async (data) => {
  const response = await Api.post('/customer/payment/get', {
    ...data,
    action: 'computation'
  });
  return response;
});
